import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/insureCompany/list',
        method: 'get',
        params: query
    })
}

export function batchSave(data) {
    return request({
        url: '/admin/insureCompany/batchSave',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/insureCompany/batchUpdate',
        method: 'post',
        data
    })
}
